import { render, staticRenderFns } from "./TheHotSignReferror.vue?vue&type=template&id=2034cbda&scoped=true&lang=pug&"
import script from "./TheHotSignReferror.vue?vue&type=script&lang=js&"
export * from "./TheHotSignReferror.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2034cbda",
  null
  
)

export default component.exports